import { gql } from "apollo-boost"

export const mutateCountCommentsMeansOfVerification = gql`
  mutation Mutation($meansOfVerification: [ID!]!) {
  MeansOfVerificationCountsComments(meansOfVerification: $meansOfVerification)
}
`